"use client";

import { useEffect, useState } from "react";

const TopScrollButton = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={handleScrollToTop}
      onTouchEnd={handleScrollToTop}
      aria-label="Scroll to top"
      className={`fixed bottom-20 right-8 z-50 w-12 h-12 rounded-full bg-[#357de5] hover:bg-[#1f5aa0] text-white shadow-lg transition-all duration-300 ${
        showButton
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <span className="text-2xl leading-none">&#8593;</span>
    </button>
  );
};

export default TopScrollButton;
